/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  return 5;
}
export default ["guz", [["Ma", "Mo"], u, ["Mambia", "Mog"]], [["Ma", "Mo"], u, u], [["C", "C", "C", "C", "A", "I", "E"], ["Cpr", "Ctt", "Cmn", "Cmt", "Ars", "Icm", "Est"], ["Chumapiri", "Chumatato", "Chumaine", "Chumatano", "Aramisi", "Ichuma", "Esabato"], ["Cpr", "Ctt", "Cmn", "Cmt", "Ars", "Icm", "Est"]], u, [["C", "F", "M", "A", "M", "J", "C", "A", "S", "O", "N", "D"], ["Can", "Feb", "Mac", "Apr", "Mei", "Jun", "Cul", "Agt", "Sep", "Okt", "Nob", "Dis"], ["Chanuari", "Feburari", "Machi", "Apiriri", "Mei", "Juni", "Chulai", "Agosti", "Septemba", "Okitoba", "Nobemba", "Disemba"]], u, [["YA", "YK"], u, ["Yeso ataiborwa", "Yeso kaiboirwe"]], 0, [6, 0], ["dd/MM/y", "d MMM y", "d MMMM y", "EEEE, d MMMM y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "HH:mm:ss zzzz"], ["{1} {0}", u, u, u], [".", ",", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "¤#,##0.00", "#E0"], "KES", "Ksh", "Shilingi ya Kenya", {
  "JPY": ["JP¥", "¥"],
  "KES": ["Ksh"],
  "USD": ["US$", "$"]
}, "ltr", plural];
